const appDetails = {
    webLink: "https://coxfarms.graindiscovery.com",
    googlePlayLink: "https://play.google.com/store/apps/details?id=com.graindiscovery.marketplace_flutter.coxfarms&hl=en_CA&gl=US",
    appStoreLink: "https://apps.apple.com/ca/app/cox-farms/id1588138786",
    landingPage: "home",
    signUpButton: true
}

export default appDetails;